import React from 'react';

interface IModalHeader {
  onRequestClose?: () => void;
  alignText?: 'center' | 'left';
  borderBottom?: '1px solid #f1f1f1' | 'none';
  children?: React.ReactNode;
}

/** @deprecated - prefer `design-system/Dialog` (DialogTitle) */
export const ModalHeader: React.FC<IModalHeader> = ({
  children,
  alignText = 'center',
  borderBottom = '1px solid #f1f1f1',
  onRequestClose,
}) => {
  return (
    <header onClick={e => e.stopPropagation()}>
      {onRequestClose && (
        <button className="close" onClick={onRequestClose}>
          <svg viewBox="0 0 40 40">
            <g>
              <path d="m31.6 10.7l-9.3 9.3 9.3 9.3-2.3 2.3-9.3-9.3-9.3 9.3-2.3-2.3 9.3-9.3-9.3-9.3 2.3-2.3 9.3 9.3 9.3-9.3z" />
            </g>
          </svg>
        </button>
      )}
      {children}
      <style jsx>{`
        header {
          flex-shrink: 0;
          font-weight: bold;
          font-size: 18px;
          border-bottom: ${borderBottom};
          padding: 20px;
          text-align: ${alignText};
          position: relative;
        }

        .close {
          background: rgba(241, 241, 241, 1);
          width: 22px;
          height: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100px;
          position: absolute;
          right: 16px;
          cursor: pointer;
          transition: all 0.3s;
          padding: 0;
          border: 0;
        }

        .close:hover {
          background: rgba(225, 225, 225, 1);
        }

        svg {
          width: 14px;
        }
      `}</style>
    </header>
  );
};
